import React from 'react';
import { TextInput } from '@instinet-analytics/semantic-ui-components';

interface StringControlProps {
    columnName?: string | null;
    value?: string;
    onChange: (value: string) => void;
    onInputEnter: () => void;
}

export default function StringControl(props: StringControlProps) {
    const { columnName, value, onChange, onInputEnter } = props;
    return (
        <TextInput
            value={value || ''}
            onChange={onChange}
            onEnter={onInputEnter}
            placeholder={`Enter a ${columnName}`}
        />
    );
}
